import { render, staticRenderFns } from "./JournalFilesViewItem.vue?vue&type=template&id=46741250&scoped=true&"
import script from "./JournalFilesViewItem.vue?vue&type=script&lang=ts&"
export * from "./JournalFilesViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFilesViewItem.vue?vue&type=style&index=0&id=46741250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46741250",
  null
  
)

export default component.exports